import { PusherEventPayload } from 'actions/pusher';
import { NotificationEntity, Notification } from 'types/notifications';

export const mapPusherEventPayloadToNotification = (payload: PusherEventPayload) => ({
  ...payload.data,
  event: payload.event,
});

export const mapNotificationEntityToNotification = (notificationEntity: NotificationEntity) => {
  const { id, type, status, event, createdAt, sender, refId } = notificationEntity;
  const data = JSON.parse(notificationEntity.data);

  return {
    id,
    type,
    status,
    event,
    createdAt,
    sender,
    refId,
    ...data,
  };
};

export const orderByDate = (a: Notification, b: Notification) =>
  +new Date(b.createdAt) - +new Date(a.createdAt);
